import { application } from "./application"
import AccountSearchController from "./account_search_controller"
import AssetClassFieldsController from "./asset_class_fields_controller"
import MobileOtpController from "./mobile_otp_controller"
import ApiDataFeedAuthController from "./api_data_feed_auth_controller"
import DashboardWidgetController from "./dashboard_widget_controller"
import DashboardWidgetsController from "./dashboard_widgets_controller"
import PanelModalController from "./panel_modal_controller"
import PanelSortController from "./panel_sort_controller"
import PropertySearchController from "./property_search_controller"
import ReportBuilderController from "./report_builder_controller"
import ScheduleCalendarController from "./schedule_calendar_controller"
import SchedulingUtilizationConfigController from "./scheduling_utilization_config_controller"
import WidgetScrollController from "./widget_scroll_controller"

application.register("account-search", AccountSearchController)
application.register("asset-class-fields", AssetClassFieldsController)
application.register("mobile-otp", MobileOtpController)
application.register("api-data-feed-auth", ApiDataFeedAuthController)
application.register("dashboard-widget", DashboardWidgetController)
application.register("dashboard-widgets", DashboardWidgetsController)
application.register("panel-modal", PanelModalController)
application.register("panel-sort", PanelSortController)
application.register("property-search", PropertySearchController)
application.register("report-builder", ReportBuilderController)
application.register("schedule-calendar", ScheduleCalendarController)
application.register("scheduling-utilization-config", SchedulingUtilizationConfigController)
application.register("widget-scroll", WidgetScrollController)
